import uuid from '@vend/vend-uuid'
import { UnknownLineItem } from '../models/line-item'

export function createUnknownLineItem(name: string): UnknownLineItem {
  return {
    localId: uuid(),
    name,
    dateAdded: Date.now(),
  }
}

export function removeUnknownLineItemByLocalId(
  unknownLineItems: UnknownLineItem[],
  localIdToRemove: string
): UnknownLineItem[] {
  return unknownLineItems.filter(i => i.localId !== localIdToRemove)
}
